// Save this as /Users/kacey/BoxyQR_Website/BoxyQR/boxyQR_website/client/src/utils/accountDeletion.js

/**
 * Handles the complete account deletion process
 * @param {Object} options - Configuration options
 * @param {string} options.accountId - MongoDB Account ID
 * @param {Object} options.user - Clerk user object
 * @param {Function} options.setError - Function to set error state
 * @param {Function} options.setProcessingPayment - Function to set loading state
 * @returns {Promise<void>}
 */
// Update your utils/accountDeletion.js file:

export const handleDeleteAccount = async ({
  accountId,
  user,
  setError,
  setProcessingPayment
}) => {
  try {
    
    console.log("handleDeleteAccount called");
    
    if (!accountId || !user) {
      console.error("Missing required data: accountId or user");
      if (setError) {
        setError('Your account is not properly set up. Please contact support.');
      }
      return;
    }
    
    // Start the deletion process with a loading state
    if (setProcessingPayment) {
      setProcessingPayment(true);
    }
    
    console.log(`Starting account deletion process for accountId: ${accountId}`);
    
    // 1. First attempt to sign out from Clerk
    try {
      if (window.Clerk) {
        console.log("Signing out from Clerk first");
        await window.Clerk.signOut();
        console.log("Successfully signed out from Clerk");
      }
    } catch (signOutError) {
      console.error("Error signing out from Clerk:", signOutError);
      // Continue with process even if sign out fails
    }
    
    // 2. Delete MongoDB data
    console.log(`Sending DELETE request to /api/account/${accountId}`);
    const response = await fetch(`/api/account/${accountId}`, {
      method: 'DELETE',
    });
    if (user?.id) {
      try {
        await fetch(`/api/clerk-user/${user.id}`, {
          method: 'DELETE'
        });
        console.log("Successfully deleted user from Clerk");
      } catch (clerkError) {
        console.error("Error deleting from Clerk:", clerkError);
        // Continue anyway
      }
    }
    
    let responseData;
    try {
      responseData = await response.json();
      console.log(`Delete response (status ${response.status}):`, responseData);
    } catch (e) {
      console.error("Error parsing response:", e);
      // If we can't parse as JSON, create a basic response
      responseData = { success: response.ok };
    }
    
    if (!response.ok) {
      const errorMessage = responseData?.error || 'Failed to delete account data';
      console.error(`Delete MongoDB data failed: ${errorMessage}`);
      throw new Error(errorMessage);
    }
    
    // 3. On success, redirect to deleted page
    console.log("MongoDB account deletion successful, redirecting");
    window.location.href = '/account-deleted';

    
  } catch (err) {
    console.error('Error deleting account:', err);
    if (setError) {
      setError(err.message || 'An error occurred while deleting your account. Try refreshing the page.');
    }
    if (setProcessingPayment) {
      setProcessingPayment(false);
    }
  }
};